<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M16 13.4V17.6C16 21.1 14.6 22.5 11.1 22.5H6.9C3.4 22.5 2 21.1 2 17.6V13.4C2 9.9 3.4 8.5 6.9 8.5H11.1C14.6 8.5 16 9.9 16 13.4Z"
    stroke="#828181" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M22 7.4V11.6C22 15.1 20.6 16.5 17.1 16.5H16V13.4C16 9.9 14.6 8.5 11.1 8.5H8V7.4C8 3.9 9.4 2.5 12.9 2.5H17.1C20.6 2.5 22 3.9 22 7.4Z"
    stroke="#828181" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
